import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';
import WrapperWidgetIcon, {
  CLOSE_ICON
} from "../../DynamicFormBuilderScreen/Widgets/WrapperWidgetIcon";

class Tab extends React.Component {
  onClick = () => {
    const { label, onClick } = this.props;
    onClick(label);
  }

  onCancel = () => {
    const { onClickCancel, groupId, triggerId, time, index } = this.props;
    const data = { groupId, triggerId, time };
    onClickCancel(data, index);
  }

  render() {
    const {
      onClick,
      onCancel,
      props: {
        activeTab,
        label,
      },
    } = this;

    let className = 'Tab_List__Item';

    if (activeTab === label) {
      className += ' Tab_List__Active';
    }

    return (
      <li
        className={className}
      >
        <span className='Inline' onClick={onClick}>
          <div dangerouslySetInnerHTML={{__html: label}}/>
        </span>
        { label !== 'Dynamic Form' &&
          <WrapperWidgetIcon
            display
            type={CLOSE_ICON}
            className='Icon-Close'
            onClick={onCancel}
          />
        }
      </li>
    );
  }
}

Tab.propTypes = {
  activeTab: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default Tab;